import { Component } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'app-decline-booking-reason',
    templateUrl: 'decline-booking-reason.html'
})
export class DeclineBookingReasonComponent {
    reasonControl = new FormControl('', Validators.required)

    // Constructor
    constructor(private _dialogRef: MatDialogRef<DeclineBookingReasonComponent>) {}

    // Public
    cancel() {
        this._dialogRef.close(undefined)
    }

    decline() {
        this._dialogRef.close(this.reasonControl.value)
    }
}
